<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { WizardFieldType } from '@/types/wizard-forms'

const emit = defineEmits<{
  add: [type: WizardFieldType]
}>()

const { t } = useI18n()

interface FieldTypeEntry {
  type: WizardFieldType
  icon: string
  labelKey: string
}

const FIELD_TYPES: FieldTypeEntry[] = [
  { type: 'text', icon: 'T', labelKey: 'wizard_forms.field_types.text' },
  { type: 'textarea', icon: '¶', labelKey: 'wizard_forms.field_types.textarea' },
  { type: 'number', icon: '#', labelKey: 'wizard_forms.field_types.number' },
  { type: 'date_picker', icon: '📅', labelKey: 'wizard_forms.field_types.date_picker' },
  { type: 'checkbox', icon: '☑', labelKey: 'wizard_forms.field_types.checkbox' },
  { type: 'checkbox_group', icon: '☑☑', labelKey: 'wizard_forms.field_types.checkbox_group' },
  { type: 'radio_group', icon: '◉', labelKey: 'wizard_forms.field_types.radio_group' },
  { type: 'select', icon: '▼', labelKey: 'wizard_forms.field_types.select' },
]
</script>

<template>
  <div class="space-y-1.5">
    <p class="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">
      {{ t('wizard_forms.toolbox.heading') }}
    </p>
    <button
      v-for="entry in FIELD_TYPES"
      :key="entry.type"
      type="button"
      class="w-full flex items-center gap-3 rounded-lg px-3 py-2.5 bg-slate-700/40 hover:bg-slate-700 border border-slate-600 hover:border-slate-500 text-slate-300 hover:text-white transition-colors text-sm"
      @click="emit('add', entry.type)"
    >
      <span class="w-7 h-7 rounded bg-slate-600 flex items-center justify-center text-xs font-mono shrink-0">
        {{ entry.icon }}
      </span>
      <span class="font-medium">{{ t(entry.labelKey) }}</span>
    </button>
  </div>
</template>
